<template lang="pug">
  .mt-5
    h4.mx-1 {{ name }}
    v-row(no-gutters)
      v-col(
        v-for='(item,i) in gameBalance'
        :key='i'
        :cols="(gameBalance.length%4===1 || gameBalance.length%4===3) && i>=gameBalance.length-1 ? '12': '6'" 
        :md=" \
      (gameBalance.length%4===1&&i>=gameBalance.length-1) ? '12':\
      (gameBalance.length%4===3&&i>=gameBalance.length-1) ? '6' :\
      (gameBalance.length%4===2&&i>=gameBalance.length-2) ? '6' :'3'"
      )
        v-row.pa-1(
          v-for='(item2,index) in item.round_rooms'
          :key='index'
          :style="item.round_rooms.length === 1 ? 'height:100%;' : '' ", no-gutters
        )
          card-lotto(
            :msg='item2'
            :type-id='typeId'
            @sortdata='sortdata' 
          )
    v-row.pt-3(
      v-if='game_rounds.length>40'
      no-gutters
      justify="center"
    )
      v-btn(
        small
        rounded 
        depressed
        :class='classCardForm'
        @click='expandStatusChange ()'
      )
        div(v-if='!expandStatus')
          | {{ $t('button.more') }}
          v-icon(small) mdi-chevron-double-down
        div(v-else)
          | {{ $t('button.short') }}
          v-icon(small) mdi-chevron-double-up

</template>
<script>  
import CardLotto from './CardLotto'
import { classCardColor } from '@/const/gameId'
export default {
  components:{ 
    CardLotto, 
  },
  props : {
    transferData:{
      type:Object,
      default : function (){
        return {}
      }
    }, 
  },
  data () {
    return { 
      game_rounds:this.transferData.game_rounds,
      typeId:this.transferData.id,
      name : this.transferData.name,
      expandStatus : false
    }
  },   
  
  computed : {
    gameRoundSlice () {
      return this.game_rounds.slice(0,2)
    },

    gameBalance () {
      return this.game_rounds.length>40 && !this.expandStatus ? this.gameRoundSlice : this.game_rounds
    },

    classCardForm () { 
      return classCardColor(this.typeId)  
    }
  },

  methods : {
    sortdata () {
      this.$emit('sortdata')
    },
    expandStatusChange () {
      this.$ga.event('Button', 'ExpandCardForm', 'LottoPage','' )
      this.expandStatus = !this.expandStatus
    }
  }
}
</script>   